import { DishForTree } from "../../../../../interfaces/meMenuInterfaces/interfaces";

export const buildNodeToDishIdsMap = (dishes: DishForTree[]): Record<string, number[]> => {
    const map: Record<string, number[]> = {};

    dishes.forEach((dish) => {
        const { id: dishId, categoryId, subcategoryId } = dish;

        const leafKey = String(dishId);
        if (!map[leafKey]) map[leafKey] = [];
        map[leafKey].push(dishId);

        const categoryKey = `cat_${categoryId}`;
        if (!map[categoryKey]) map[categoryKey] = [];
        map[categoryKey].push(dishId);

        if (subcategoryId) {
            const subKey = `sub_${subcategoryId}`;
            if (!map[subKey]) map[subKey] = [];
            map[subKey].push(dishId);
        }
    });

    return map;
};
